import { Partner } from "@types-runway/state";

import { admin } from "../../../api";

const useCreatePartner = () => {
  const postPartner = async (partner: Partner): Promise<Partner | null> => {
    try {
      const { data } = await admin.partnerPost("", partner);
      return data;
    } catch {
      return null;
    }
  };
  return { postPartner };
};

export default useCreatePartner;
